import { httpTrafficLights } from 'shared/services/http/httpClient';
import {
  RulesConfiguration,
  RulesConfigurationListResponse
} from '../models/RulesConfigurationModels';
import { RulesConfigurationFormType } from '../types/types';

export const trafficLightRulesConfigurationService = () => {
  const getRulesConfigurations = async (
    page: number = 1,
    page_size: number = 10
  ): Promise<RulesConfigurationListResponse> => {
    const response = await httpTrafficLights.get('semaphore-rule-groups', {
      params: {
        page,
        page_size
      }
    });
    return {
      docs: response.rows,
      totalDocs: response.total
    };
  };

  const getSemaphoreRuleGroupById = async (id: number): Promise<RulesConfiguration> => {
    const response = await httpTrafficLights.get(`semaphore-rule-groups/${id}`);
    return response;
  };

  const createSemaphoreRuleGroup = async (
    values: RulesConfigurationFormType
  ): Promise<void> => {
    await httpTrafficLights.post('semaphore-rule-groups', values);
  };

  const updateSemaphoreRuleGroup = async (
    id: number,
    values: RulesConfigurationFormType
  ): Promise<void> => {
    await httpTrafficLights.put(`semaphore-rule-groups/${id}`, values);
  };

  const deleteSemaphoreRuleGroup = async (id: number): Promise<void> => {
    await httpTrafficLights.delete(`semaphore-rule-groups/${id}`);
  };

  return {
    getRulesConfigurations,
    getSemaphoreRuleGroupById,
    createSemaphoreRuleGroup,
    updateSemaphoreRuleGroup,
    deleteSemaphoreRuleGroup
  };
};

